import React from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'
import { getSafe } from '@/helpers/global';
import { ACCOUNT_TYPE } from '@/constants/auth';
import { Icons } from '@/configurations/app-configs/app-icons'
import CashAccountMobile from '../../@app/CashAccount/CashAccount.mobile';
import AccountBalanceMobile from '@/components/MyAccount/AccountBalance/AccountBalance.mobile';
import { getPortfolioAction, getAccountBalanceAction } from '@/actions/trading';
import { PARAMS } from '@/constants/params';
import { SERVICES_RESP } from '@/configurations';
import { Converter } from '@/helpers/functions';
import { mobileSubLayoutAction } from '@/actions/app/mobileSubLayout.action';
import { LOADING_TYPE } from '@/constants/app';
import LoadingLayer from '@/components/Spinner/LoadingLayer';
import PositionProportionMobile from '../PositionProportion/PositionProportionMobile';
import '../../../assets/styles/components/position-proportion/position-proportion-mobile.scss'

class CashAccountAccountProfileMobile extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      expand: true,
      cashAccountData: {},
      portfolioData: {},
      detailsList: [],
      load:false
    }
  }

  render() {
    const { language, tradingAccount, currentTradingAccount} = this.props
    const { expand, cashAccountData, portfolioData, detailsList , load} = this.state;
    return (
      <React.Fragment>
        <div className="cash-account-mobile">
        <LoadingLayer load={load} type={LOADING_TYPE.BIG_IMG} />
          <header onClick={() => mobileSubLayoutAction.openSwitchAccount()} >
            <span>
             {currentTradingAccount.tradingAccountID ? `${currentTradingAccount.accountType==='M' ? language.common_margin_account : language.common_cash_account}: ${currentTradingAccount.tradingAccountID}`
              : `${currentTradingAccount.accountType==='M' ? language.common_margin_account : language.common_cash_account}: ${currentTradingAccount.label}`
            }
            </span>
            <div className="list-enter-icon"><Icons.RightArrow /></div>
          </header>
          <section>
            <div className={classnames('top', expand ? 'expand-top' : '')}>
              <div className={classnames('top', expand ? 'expand-top' : '', "item")}>
                <div className="row">
                  <CashAccountMobile cashAccountData={cashAccountData} portfolioData={portfolioData} topPart={true} />
                </div>
                <div className="expand-content">
                  <CashAccountMobile cashAccountData={cashAccountData} portfolioData={portfolioData} contentExpand={true} />
                </div>
                <div className={classnames("drop-icon", expand ? "reverse" : "")} onClick={() => this.openExpand()}></div>
              </div>
            </div>
            <div>
              <PositionProportionMobile innerRef={e => this.PositionProportionMobileRef = e}/>
            </div>
          </section>
          <section>
            <div>
              <span>{getSafe(() => language.account_balance_title)}</span>
            </div>
            <AccountBalanceMobile detailsList={detailsList} />
          </section>
        </div>
      </React.Fragment>
    )
  }

  openExpand = () => {
    this.setState({
      expand: !this.state.expand
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props.currentTradingAccount !== prevProps.currentTradingAccount) {
      this.getAccountBalance();
    }
  }

  componentDidMount() {
    const { currentTradingAccount } = this.props;
    if (currentTradingAccount && JSON.stringify(currentTradingAccount) !== '{}') {
      this.getAccountBalance();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return
    }
  }

  accountType = (val) => {
    switch (val) {
      case ACCOUNT_TYPE.CASH: {
        return this.props.language.common_cash
      }
      case ACCOUNT_TYPE.MARGIN: {
        return this.props.language.common_margin
      }
      case ACCOUNT_TYPE.CUSTODIAN: {
        return this.props.language.common_custodian
      }
    }
  }

  getAccountBalance = () => {
    var count = 0;
    const { user, currentTradingAccount, language, tradingAccount } = this.props;
    const { clientID, tradingAccSeq } = currentTradingAccount
    const params = {
      [PARAMS.CLIENT_ID]: clientID,
      [PARAMS.TRADING_ACCOUNT_ID]: clientID,
      [PARAMS.LANGUAGE]: language.lang,
      [PARAMS.SHOW_DETAILS]: 'Y'
    }
    this.setState({
      load: true
    })
    this.props.getAccountBalance(JSON.parse(JSON.stringify(params)), res => {
      this.setState({
        load: false
      })
      if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
        this.setState({
          cashAccountData: Converter.mapAssetAllocation(res.result),
          detailsList: res.result.detailsList,
        })
      }
    })
    this.props.getPortfolioAction(params, res => {
      if (res.errorCode === SERVICES_RESP.SUCCESS_CODE) {
        this.setState({
          portfolioData: Converter.mapAccountPL(res),
        })
      }
    })
  }
}

export default connect(
  state => ({
    language: state.app.language,
    markets: state.trade.markets,
    user: state.auth.user,
    currentTradingAccount: state.trade.currentTradingAccount,
    clientID: state.trade.clientID,
    tradingAccount: state.auth.tradingAccount,
  }),
  dispatch => ({
    getPortfolioAction: (p, res) => dispatch(getPortfolioAction(p, res)),
    getAccountBalance: (p, res) => dispatch(getAccountBalanceAction(p, res)),
  })
)(CashAccountAccountProfileMobile)